export default "__VITE_ASSET__CNfJGvwA__"